import API from "../../api";
import {API_SEARCH_INSPECTION_HISTORY_CORRECTION} from "../../constants/api";

const getInformationInspection = async (workflowId, inspectionId) => {
  try {
    const response = await API.get(API_SEARCH_INSPECTION_HISTORY_CORRECTION(workflowId, inspectionId));
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const update = async (workflowId, inspectionId, data) => {
  try {
    const response = await API.post(API_SEARCH_INSPECTION_HISTORY_CORRECTION(workflowId, inspectionId), data);
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const InspectionHistoryCorrection = {
  getInformationInspection,
  update
};

export {
  InspectionHistoryCorrection as default,
  getInformationInspection,
  update
}
